import React from 'react';
import { Grid, Paper, Stack, Box, Typography, Button } from '@mui/material';

const defaultCardPaperSx = {
  p: 4,
  borderRadius: 3,
  border: '1px solid',
  borderColor: 'divider',
  width: '100%',
  minHeight: 220,
  cursor: 'pointer',
  transition: 'transform 0.25s ease, box-shadow 0.25s ease',
  '&:hover': {
    transform: 'translateY(-4px)',
    boxShadow: 4,
  },
};

const QuickActionsGrid = ({ cards, context = {}, gridSize = { xs: 12, sm: 6, md: 4 } }) => {
  const visibleCards = cards.filter((card) => {
    if (typeof card.when === 'function') {
      return card.when(context);
    }
    if (card.when === false) {
      return false;
    }
    return true;
  });

  return (
    <Grid container spacing={3} sx={{ justifyContent: 'center', alignItems: 'stretch' }}>
      {visibleCards.map((card) => {
        if (card.component) {
          const Component = card.component;
          return (
            <Grid key={card.key || card.title || 'component-card'} size={card.gridSize || gridSize} display="flex">
              <Box sx={{ width: '100%', display: 'flex' }}>
                <Component {...(card.componentProps || {})} />
              </Box>
            </Grid>
          );
        }

        const IconComponent = card.icon;

        return (
          <Grid key={card.key || card.title} size={card.gridSize || gridSize} display="flex">
            <Paper
              onClick={card.action}
              onKeyDown={(event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                  event.preventDefault();
                  card.action?.();
                }
              }}
              role="button"
              tabIndex={0}
              sx={[defaultCardPaperSx, card.paperSx || {}]}
            >
              <Stack spacing={3} alignItems="center" textAlign="center" sx={{ height: '100%' }}>
                <Box
                  sx={{
                    width: 48,
                    height: 48,
                    borderRadius: 2,
                    backgroundColor: card.accent,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  {IconComponent && <IconComponent sx={{ color: card.iconColor || 'primary.contrastText' }} />}
                </Box>
                <Box sx={{ flexGrow: 1, width: '100%' }}>
                  <Typography variant="h6" fontWeight={600}>
                    {card.title}
                  </Typography>
                  {card.description && (
                    <Typography variant="body2" color="text.secondary">
                      {card.description}
                    </Typography>
                  )}
                  {typeof card.renderDetails === 'function' && card.renderDetails(context)}
                </Box>
                {card.actionLabel && card.action && (
                  <Button
                    variant="text"
                    color="primary"
                    onClick={(event) => {
                      event.stopPropagation();
                      card.action();
                    }}
                    sx={{ px: 0 }}
                  >
                    {card.actionLabel}
                  </Button>
                )}
              </Stack>
            </Paper>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default QuickActionsGrid;